import React, { useState, useRef, useEffect } from 'react';
import API_CONFIG from '../config/api';
import { apiFetch, getAuthenticatedUploadUrl } from '../api/client';
import {
  Box,
  Typography,
  Avatar,
  Button,
  TextField,
  Alert,
  CircularProgress,
  Modal,
  Card,
  CardContent,
  Grid,
  IconButton,
  MenuItem
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { withUnidade } from '../utils/storageByUnit';
import PolicyIcon from '@mui/icons-material/Policy';
import DownloadIcon from '@mui/icons-material/Download';

import CloseIcon from '@mui/icons-material/Close';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import LockIcon from '@mui/icons-material/Lock';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function PerfilPage() {
  const navigate = useNavigate();
  const { user, isAdmin, fotoPerfil, atualizarFotoPerfil, unidadeSelecionada, hasPermission } = useAuth();
  const [fotoFile, setFotoFile] = useState(null);
  const [fotoPreview, setFotoPreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [usuarioSelecionado, setUsuarioSelecionado] = useState('');
  const [novaSenhaOutro, setNovaSenhaOutro] = useState('');
  const [confirmarSenhaOutro, setConfirmarSenhaOutro] = useState('');
  const [novoNome, setNovoNome] = useState('');
  const [novoEmail, setNovoEmail] = useState('');
  const [novoSenha, setNovoSenha] = useState('');
  const [novoTipo, setNovoTipo] = useState('usuario');
  const [novoCpf, setNovoCpf] = useState('');
  const [novoCargo, setNovoCargo] = useState('');
  const [novoGenero, setNovoGenero] = useState('auto');
  const [novoSetor, setNovoSetor] = useState('');
  const [cargosDisponiveis, setCargosDisponiveis] = useState([]);
  const [setoresDisponiveis, setSetoresDisponiveis] = useState([]);
  const [mensagemCadastro, setMensagemCadastro] = useState('');
  const [usuarios, setUsuarios] = useState([]);
  
  // Estados para modais
  const [modalAlterarSenha, setModalAlterarSenha] = useState(false);
  const [modalAlterarSenhaOutro, setModalAlterarSenhaOutro] = useState(false);
  const [modalCadastrarUsuario, setModalCadastrarUsuario] = useState(false);
  const [modalEditarUsuario, setModalEditarUsuario] = useState(false);
  const [modalNovoCargo, setModalNovoCargo] = useState(false);
  const [modalNovoSetor, setModalNovoSetor] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [novoCargoNome, setNovoCargoNome] = useState('');
  const [novoSetorNome, setNovoSetorNome] = useState('');
  const [novoSetorDescricao, setNovoSetorDescricao] = useState('');
  
  const fileInputRef = useRef();

  // Buscar usuários e cargos para os dropdowns
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('🔍 Buscando usuários e cargos...');
        
        // Buscar usuários com filtro de unidade
        const urlUsuarios = unidadeSelecionada 
          ? `${API_CONFIG.BACKEND_URL}/api/usuarios?unidade=${encodeURIComponent(unidadeSelecionada.codigo)}`
          : `${API_CONFIG.BACKEND_URL}/api/usuarios`;
        
        const responseUsuarios = await fetch(urlUsuarios);
        console.log('📡 Status da resposta usuários:', responseUsuarios.status);
        
        if (responseUsuarios.ok) {
          const dataUsuarios = await responseUsuarios.json();
          console.log('✅ Usuários carregados:', dataUsuarios.length);
          setUsuarios(dataUsuarios);
        } else {
          console.error('❌ Erro na resposta usuários:', responseUsuarios.status);
        }
        
        // Buscar todos os cargos (corporativos + operacionais)
        const responseCargos = await fetch(`${API_CONFIG.BACKEND_URL}/api/todos-cargos`);
        console.log('📡 Status da resposta cargos:', responseCargos.status);
        
        if (responseCargos.ok) {
          const dataCargos = await responseCargos.json();
          console.log('✅ Cargos carregados:', dataCargos.cargos);
          setCargosDisponiveis(dataCargos.cargos);
        } else {
          console.error('❌ Erro na resposta cargos:', responseCargos.status);
        }
        
        // Buscar setores
        const responseSetores = await fetch(`${API_CONFIG.BACKEND_URL}/api/setores`);
        console.log('📡 Status da resposta setores:', responseSetores.status);
        
        if (responseSetores.ok) {
          const dataSetores = await responseSetores.json();
          console.log('✅ Setores carregados:', dataSetores.length);
          setSetoresDisponiveis(dataSetores);
        } else {
          console.error('❌ Erro na resposta setores:', responseSetores.status);
        }
      } catch (error) {
        console.error('❌ Erro ao buscar dados:', error);
      }
    };
    fetchData();
  }, [unidadeSelecionada]);

  // Função para lidar com a seleção de arquivo
  const handleFotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validar tipo de arquivo
      if (!file.type.startsWith('image/')) {
        setMensagem('Por favor, selecione um arquivo de imagem.');
        return;
      }
      
      // Validar tamanho (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setMensagem('A imagem deve ter no máximo 5MB.');
        return;
      }
      
      setFotoFile(file);
      
      // Criar preview
      const reader = new FileReader();
      reader.onload = () => {
        setFotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
      setMensagem('');
    }
  };

  // Função para fazer upload da foto
  const handleUploadFoto = async () => {
    if (!fotoFile || !user?.id) {
      setMensagem('Erro: arquivo ou usuário não identificado.');
      return;
    }
    
    setLoading(true);
    setMensagem('');
    
    try {
      const formData = new FormData();
      formData.append('foto', fotoFile);
      
      console.log('📸 Enviando foto para o servidor...');
      
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios/${user.id}/foto`, {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Erro ao fazer upload da foto');
      }
      
      const data = await response.json();
      console.log('✅ Foto enviada com sucesso:', data);
      
      // Atualizar foto no contexto
      await atualizarFotoPerfil(data.fotoPerfil);
      
      setMensagem('Foto atualizada com sucesso!');
      setFotoFile(null);
      setFotoPreview('');
      
      // Limpar input de arquivo
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error('❌ Erro ao fazer upload:', error);
      setMensagem(error.message || 'Erro ao atualizar foto.');
    } finally {
      setLoading(false);
    }
  };

  const handleAlterarSenha = async () => {
    // Validações no frontend
    if (!senhaAtual || !novaSenha || !confirmarSenha) {
      setMensagem('Preencha todos os campos.');
      return;
    }
    
    if (novaSenha !== confirmarSenha) {
      setMensagem('As senhas não coincidem.');
      return;
    }
    
    if (novaSenha.length < 6) {
      setMensagem('A senha deve ter no mínimo 6 caracteres.');
      return;
    }
    
    setLoading(true);
    setMensagem('');
    
    try {
      // Normalizar email antes de enviar (lowercase)
      const emailNormalizado = (user.email || '').toLowerCase().trim();
      const response = await apiFetch(`/api/usuarios/${encodeURIComponent(emailNormalizado)}/senha`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          senhaAtual: senhaAtual.trim(),
          novaSenha: novaSenha.trim()
        }),
      });

      if (response.ok) {
        setMensagem('Senha alterada com sucesso!');
        setSenhaAtual('');
        setNovaSenha('');
        setConfirmarSenha('');
        setModalAlterarSenha(false);
      } else {
        const data = await response.json();
        setMensagem(data.error || 'Erro ao alterar senha.');
      }
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      setMensagem('Erro de conexão com o servidor. Verifique se o backend está rodando.');
    } finally {
      setLoading(false);
    }
  };

  const handleAlterarSenhaOutro = async () => {
    if (!usuarioSelecionado) {
      setMensagem('Selecione um usuário.');
      return;
    }
    
    if (novaSenhaOutro !== confirmarSenhaOutro) {
      setMensagem('As senhas não coincidem.');
      return;
    }
    
    setLoading(true);
    setMensagem('');
    
    try {
      // Implementar alteração real de senha no backend
      const response = await apiFetch(`/api/usuarios/${encodeURIComponent(usuarioSelecionado)}/senha`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          novaSenha: novaSenhaOutro
        }),
      });

      if (response.ok) {
        setMensagem(`Senha do usuário ${usuarioSelecionado} alterada com sucesso!`);
        setUsuarioSelecionado('');
        setNovaSenhaOutro('');
        setConfirmarSenhaOutro('');
        setModalAlterarSenhaOutro(false);
      } else {
        const data = await response.json();
        setMensagem(data.error || 'Erro ao alterar senha.');
      }
    } catch (error) {
      setMensagem('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  // Função para buscar usuário existente por email
  const buscarUsuarioExistente = async (email) => {
    try {
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios/buscar/${encodeURIComponent(email)}`);
      const data = await response.json();
      
      if (data.exists) {
        return data.usuario;
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar usuário:', error);
      return null;
    }
  };

  // Função para preencher formulário com dados do usuário existente
  const preencherFormularioComUsuarioExistente = (usuario) => {
    setNovoNome(usuario.nome);
    setNovoEmail(usuario.email);
    setNovoTipo(usuario.tipo);
    setNovoCpf(usuario.cpf || '');
    setNovoCargo(usuario.cargo || '');
    setNovoGenero(usuario.genero || 'auto');
    setNovoSetor(usuario.setor || '');
    setNovoSenha(''); // Não preencher senha por segurança
  };

  const handleCadastrarUsuario = async () => {
    if (!novoNome || !novoEmail || !novoSenha || !novoTipo) {
      setMensagemCadastro('Preencha todos os campos obrigatórios.');
      return;
    }
    
    // Verificar se o usuário já existe
    const usuarioExistente = await buscarUsuarioExistente(novoEmail);
    if (usuarioExistente) {
      setMensagemCadastro(`Usuário com email ${novoEmail} já existe. Deseja atualizar os dados?`);
      // Preencher formulário com dados existentes
      preencherFormularioComUsuarioExistente(usuarioExistente);
      return;
    }
    
    setLoading(true);
    setMensagemCadastro('');
    
    try {
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: novoNome,
          email: novoEmail,
          senha: novoSenha,
          tipo: novoTipo,
          cpf: novoCpf || null,
          cargo: novoCargo || null,
          genero: novoGenero,
          setor: novoSetor || null,
          unidade: unidadeSelecionada?.codigo || null
        }),
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        const tipoTexto = novoTipo === 'admin' ? 'Administrador' : 
                          novoTipo === 'usuario' ? 'Usuário' : 
                          data.cargo || novoTipo;
        
        setMensagemCadastro(`Usuário ${novoNome} (${novoEmail}) cadastrado como ${tipoTexto}!`);
        
        // Atualizar lista de usuários
        const responseUsuarios = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios?unidade=${encodeURIComponent(unidadeSelecionada.codigo)}`);
        if (responseUsuarios.ok) {
          const dataUsuarios = await responseUsuarios.json();
          setUsuarios(dataUsuarios);
        }
        
        // Limpar campos
        setNovoNome('');
        setNovoEmail('');
        setNovoSenha('');
        setNovoTipo('usuario');
        setNovoCpf('');
        setNovoCargo('');
        setNovoGenero('auto');
        setNovoSetor('');
        setModalCadastrarUsuario(false);
      } else {
        setMensagemCadastro(data.error || 'Erro ao cadastrar usuário.');
      }
    } catch (err) {
      setMensagemCadastro('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  // Função para criar novo cargo
  const handleCriarNovoCargo = async () => {
    if (!novoCargoNome.trim()) {
      setMensagemCadastro('Digite o nome do novo cargo.');
      return;
    }
    
    setLoading(true);
    setMensagemCadastro('');
    
    try {
      // Por enquanto, apenas adicionar à lista local
      const novoCargo = novoCargoNome.trim().toLowerCase().replace(/\s+/g, '_');
      setCargosDisponiveis([...cargosDisponiveis, novoCargo]);
      setNovoCargo(novoCargo);
      setNovoCargoNome('');
      setModalNovoCargo(false);
      setMensagemCadastro(`Novo cargo "${novoCargoNome}" criado com sucesso!`);
    } catch (err) {
      setMensagemCadastro('Erro ao criar novo cargo.');
    } finally {
      setLoading(false);
    }
  };

  // Função para criar novo setor
  const handleCriarNovoSetor = async () => {
    if (!novoSetorNome.trim()) {
      setMensagemCadastro('Digite o nome do novo setor.');
      return;
    }
    
    setLoading(true);
    setMensagemCadastro('');
    
    try {
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/setores`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome: novoSetorNome.trim(),
          descricao: novoSetorDescricao.trim()
        }),
      });
      
      if (response.ok) {
        const novoSetor = await response.json();
        setSetoresDisponiveis([...setoresDisponiveis, novoSetor]);
        setNovoSetor(novoSetor.nome);
        setNovoSetorNome('');
        setNovoSetorDescricao('');
        setModalNovoSetor(false);
        setMensagemCadastro(`Novo setor "${novoSetorNome}" criado com sucesso!`);
      } else {
        const error = await response.json();
        setMensagemCadastro(error.error || 'Erro ao criar setor.');
      }
    } catch (err) {
      setMensagemCadastro('Erro ao criar novo setor.');
    } finally {
      setLoading(false);
    }
  };

  // Função para editar usuário
  const handleEditarUsuario = async () => {
    if (!usuarioEditando || !usuarioEditando.nome || !usuarioEditando.email || !usuarioEditando.tipo) {
      setMensagemCadastro('Preencha todos os campos obrigatórios.');
      return;
    }

    setLoading(true);
    try {
      console.log('Editando usuário:', usuarioEditando);
      
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios/${usuarioEditando.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: usuarioEditando.nome,
          email: usuarioEditando.email,
          tipo: usuarioEditando.tipo,
          cpf: usuarioEditando.cpf || null,
          cargo: usuarioEditando.cargo || null,
          genero: usuarioEditando.genero || 'auto',
          setor: usuarioEditando.setor || null,
          unidade: usuarioEditando.unidade || unidadeSelecionada?.codigo || null
        })
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok) {
        setMensagemCadastro('Usuário atualizado com sucesso!');
        setModalEditarUsuario(false);
        setUsuarioEditando(null);
        // Recarregar lista de usuários
        const responseUsuarios = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios`);
        if (responseUsuarios.ok) {
          const dataUsuarios = await responseUsuarios.json();
          setUsuarios(dataUsuarios);
        }
      } else {
        setMensagemCadastro(data.error || 'Erro ao atualizar usuário.');
      }
    } catch (err) {
      console.error('Erro ao editar usuário:', err);
      setMensagemCadastro('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  // Função para deletar usuário
  const handleDeletarUsuario = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este usuário?')) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios/${id}`, {
        method: 'DELETE'
      });

      const data = await response.json();
      if (response.ok) {
        setMensagemCadastro('Usuário deletado com sucesso!');
        // Recarregar lista de usuários
        const responseUsuarios = await fetch(`${API_CONFIG.BACKEND_URL}/api/usuarios`);
        if (responseUsuarios.ok) {
          const dataUsuarios = await responseUsuarios.json();
          setUsuarios(dataUsuarios);
        }
      } else {
        setMensagemCadastro(data.error || 'Erro ao deletar usuário.');
      }
    } catch (err) {
      setMensagemCadastro('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  // Função para abrir modal de edição
  const abrirModalEdicao = (usuario) => {
    console.log('Abrindo modal para editar:', usuario);
    setUsuarioEditando({ ...usuario });
    setModalEditarUsuario(true);
  };

  // Usar apenas usuários cadastrados para o dropdown (sem fiscais)
  const usuariosParaDropdown = usuarios;

  const handleExportarDadosLgpd = async (formato = 'json') => {
    setLoading(true);
    setMensagem('');
    try {
      const res = await apiFetch(withUnidade(`/api/lgpd/meus-dados/exportar?formato=${formato}`, unidadeSelecionada));
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Erro ao exportar dados');
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `meus-dados-lgpd-${user?.id || 'usuario'}.${formato === 'pdf' ? 'pdf' : 'json'}`;
      a.click();
      URL.revokeObjectURL(url);
      setMensagem('Dados exportados com sucesso (LGPD Art. 18 — portabilidade).');
    } catch (e) {
      setMensagem(e.message || 'Erro ao exportar dados.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom fontWeight={600} sx={{ mb: 4 }}>
        Perfil do Usuário
      </Typography>

      {/* Seção de Foto */}
      <Card sx={{ mb: 1 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Foto do Perfil
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, mb: 2 }}>
            <Avatar
              src={fotoPreview || (fotoPerfil ? getAuthenticatedUploadUrl(fotoPerfil) : '')}
              sx={{ 
                width: 150, 
                height: 150, 
                fontSize: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                objectFit: 'cover',
                objectPosition: 'center top',
                border: '3px solid #e3f2fd',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }}
            >
              {(!fotoPerfil && !fotoPreview) && (user?.nome?.[0] || 'U')}
            </Avatar>
            <Box>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*" 
                onChange={handleFotoChange} 
                style={{ display: 'none' }}
              />
              <Button
                variant="outlined"
                startIcon={<PhotoCameraIcon />}
                onClick={() => fileInputRef.current?.click()}
                sx={{ mb: 1 }}
                disabled={loading}
              >
                Selecionar Foto
              </Button>
              {fotoFile && (
                <Button
                  variant="contained"
                  onClick={handleUploadFoto}
                  disabled={loading}
                  sx={{ ml: 1 }}
                >
                  {loading ? <CircularProgress size={20} /> : 'Salvar Foto'}
                </Button>
              )}
            </Box>
          </Box>
          
          {mensagem && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {mensagem}
            </Alert>
          )}
        </CardContent>
      </Card>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>Proteção de Dados (LGPD)</Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Consulte as políticas de privacidade, exporte seus dados pessoais ou acesse o painel de auditoria (administradores).
          </Typography>
          <Box display="flex" gap={1} flexWrap="wrap">
            <Button variant="outlined" startIcon={<PolicyIcon />} onClick={() => navigate('/lgpd')}>
              Ver políticas
            </Button>
            <Button variant="outlined" startIcon={<DownloadIcon />} onClick={() => handleExportarDadosLgpd('json')} disabled={loading}>
              Exportar meus dados (JSON)
            </Button>
            <Button variant="outlined" startIcon={<DownloadIcon />} onClick={() => handleExportarDadosLgpd('pdf')} disabled={loading}>
              Exportar meus dados (PDF)
            </Button>
          </Box>
        </CardContent>
      </Card>

      {/* Botões de Ação */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={hasPermission('GestaoUsuarios') ? 6 : 12}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LockIcon />}
            onClick={() => setModalAlterarSenha(true)}
            sx={{ py: 2 }}
          >
            Alterar Senha
          </Button>
        </Grid>
        {hasPermission('GestaoUsuarios') && (
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              fullWidth
              startIcon={<PersonAddIcon />}
              onClick={() => navigate('/gestao-usuarios')}
              sx={{ py: 2 }}
            >
              Gestão de Equipe e Acessos
            </Button>
          </Grid>
        )}
      </Grid>

      {/* Informações do Usuário */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Informações do Usuário
          </Typography>
          
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Nome"
                value={user?.nome || ''}
                fullWidth
                disabled
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="E-mail"
                value={user?.email || ''}
                fullWidth
                disabled
                sx={{ mb: 2 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Tipo de Usuário"
                value={isAdmin ? 'Administrador' : (user?.tipo === 'fiscal' ? 'Fiscal' : user?.tipo === 'financeiro' ? 'Financeiro' : user?.tipo === 'diretoria_executiva' ? 'Diretoria Executiva' : user?.tipo === 'diretor_presidente' ? 'Diretor Presidente' : user?.tipo === 'diretor_financeiro' ? 'Diretor Financeiro' : user?.tipo === 'diretor_tecnico' ? 'Diretor Técnico' : user?.tipo === 'gerente_corporativo' ? 'Gerente Corporativo' : 'Usuário')}
                fullWidth
                disabled
                sx={{ mb: 2 }}
              />
            </Grid>
            {user?.cargo && (
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Cargo"
                  value={user.cargo}
                  fullWidth
                  disabled
                  sx={{ mb: 2 }}
                />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>



      {/* Modal Alterar Senha */}
      <Modal
        open={modalAlterarSenha}
        onClose={() => setModalAlterarSenha(false)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Card sx={{ maxWidth: 400, width: '90%' }}>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h6">Alterar Senha</Typography>
              <IconButton onClick={() => setModalAlterarSenha(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            
            <TextField
              label="Senha Atual"
              type="password"
              fullWidth
              value={senhaAtual}
              onChange={e => setSenhaAtual(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Nova Senha"
              type="password"
              fullWidth
              value={novaSenha}
              onChange={e => setNovaSenha(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Confirmar Nova Senha"
              type="password"
              fullWidth
              value={confirmarSenha}
              onChange={e => setConfirmarSenha(e.target.value)}
              sx={{ mb: 2 }}
            />
            
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                onClick={handleAlterarSenha}
                disabled={loading}
                fullWidth
              >
                {loading ? <CircularProgress size={20} /> : 'Alterar Senha'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Modal>
    </Box>
  );
}

